import nfsExports from '@/common/store/modules/nfsExports';
import { composeVuexModule } from '@/common/utils/store.util';
import abgwGeoReplication from './abgw/abgw-geo-replication';
import activities from './activities';
import alerts from './alerts';
import certificate from './certificate';
import compute from './compute';
import computeNodes from './computeNodes';
import dns from './dns';
import domainProps from './domainProps';
import domains from './domains';
import errors from './errors';
import floatingIps from './floatingIps';
import forms from './forms';
import ha from './ha';
import iscsi from './iscsi';
import joinNodeDisks from './joinNodeDisks';
import kerberos from './kerberos';
import lbaas from './lbaas';
import locationNames from './locationNames';
import locations from './locations';
import managementNodeBackup from './managementNodeBackup';
import networks from './networks';
import nfsCluster from './nfsCluster';
import nfsLdapSettings from './nfsLdapSettings';
import nfsShare from './nfsShares';
import nodes from './nodes';
import nodesDisks from './nodesDisks';
import nodesFiberChannel from './nodesFiberChannel';
import nodesISCSIDisks from './nodesISCSIDisks';
import nodesInterfaces from './nodesInterfaces';
import notifications from './notifications';
import occupiedFailureDomains from './occupiedFailureDomains';
import problemReport from './problemReport';
import projects from './projects';
import reconfiguration from './reconfiguration';
import rolesets from './rolesets';
import routers from './routers';
import s3Users from './s3Users';
import securityGroups from './securityGroups';
import servers from './servers';
import settings from './settings';
import socket from './socket';
import sslSettings from './sslSettings';
import subnets from './subnets';
import tasks from './tasks';
import updates from './updatesV3';
import vpn from './vpn';
import storeModulesGroups from './storeModulesGroups';

const preComposedModules = {
  abgwGeoReplication,
  activities,
  alerts,
  certificate,
  compute,
  computeNodes,
  dns,
  domainProps,
  domains,
  errors,
  floatingIps,
  forms,
  ha,
  iscsi,
  joinNodeDisks,
  kerberos,
  lbaas,
  locationNames,
  locations,
  managementNodeBackup,
  networks,
  nfsCluster,
  nfsExports,
  nfsLdapSettings,
  nfsShare,
  nodes,
  nodesDisks,
  nodesFiberChannel,
  nodesISCSIDisks,
  nodesInterfaces,
  notifications,
  occupiedFailureDomains,
  problemReport,
  projects,
  reconfiguration,
  rolesets,
  routers,
  s3Users,
  securityGroups,
  servers,
  settings,
  socket,
  sslSettings,
  subnets,
  tasks,
  updates,
  vpn
};

const modules = Object.keys(preComposedModules).reduce((result, key) => {
  const module = preComposedModules[key];

  if (module) {
    const moduleName = module.name || key;

    result[moduleName] = composeVuexModule({ name: moduleName, ...module });
  }

  return result;
}, {});

const initialModules = storeModulesGroups.default.reduce((result, key) => {
  result[key] = modules[key];

  return result;
}, {});

const grouppedModules = Object.keys(storeModulesGroups).reduce((result, key) => {
  result[key] = storeModulesGroups[key].map(name => modules[name]);

  return result;
}, {});

export default modules;
export { storeModulesGroups, grouppedModules, initialModules };
